/**
 * Sanitizare HTML pentru conținut de notițe randat în afara editorului Tiptap.
 *
 * Editorul parsează HTML-ul prin schema ProseMirror, care aruncă tot ce nu
 * cunoaște. Dar există două căi care ocolesc schema: preview-ul versiunilor
 * vechi (`dangerouslySetInnerHTML`) și importul de Markdown (`marked` lasă
 * HTML-ul brut din fișier să treacă). Conținutul vine de la oricine poate scrie
 * notița sau de la un fișier importat, deci îl tratăm ca nesigur — CSP-ul e a
 * doua linie de apărare, nu prima.
 */
import DOMPurify from 'dompurify';

const FORBID_TAGS = [
  'style', // CSS arbitrar (CSP permite `style-src 'unsafe-inline'`)
  'form', // phishing de parolă master prin formular injectat
  'button',
  'textarea',
  'select',
  'iframe',
  'object',
  'embed',
  'base',
  'link',
  'meta',
];

export function sanitizeHtml(html: string): string {
  return DOMPurify.sanitize(html, { FORBID_TAGS, FORBID_ATTR: ['formaction'] });
}
